"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require("react-intl");

var _table_component = require("../global_components/table_component");

var _table_component2 = _interopRequireDefault(_table_component);

var _ramda = require("ramda");

var _number_utility = require("../../../../packages/common-utilities/src/number_utility");

var _number_utility2 = _interopRequireDefault(_number_utility);

var _date_formatter = require("../../../../packages/common-utilities/src/date_formatter");

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _functional_utility = require("../../../../packages/common-utilities/src/functional_utility");

var _disclosure = require("../disclosure");

var _disclosure2 = _interopRequireDefault(_disclosure);

var _string_utility = require("../../../../packages/common-utilities/src/string_utility");

var _string_utility2 = _interopRequireDefault(_string_utility);

var _accessibility_utility = require("../../../../packages/common-utilities/src/accessibility_utility");

var _accessibility_utility2 = _interopRequireDefault(_accessibility_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IcFundOverview = function (_React$Component) {
    _inherits(IcFundOverview, _React$Component);

    function IcFundOverview(props) {
        _classCallCheck(this, IcFundOverview);

        var _this = _possibleConstructorReturn(this, (IcFundOverview.__proto__ || Object.getPrototypeOf(IcFundOverview)).call(this, props));

        _this.state = {
            extendHeight: false
        };
        return _this;
    }

    _createClass(IcFundOverview, [{
        key: "componentWillMount",
        value: function componentWillMount() {
            this.setStateForExtendHeight(this.props.data);
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            this.setStateForExtendHeight(nextProps.data);
        }
    }, {
        key: "setStateForExtendHeight",
        value: function setStateForExtendHeight(data) {
            var shouldExtendHeight = data.some(function (d) {
                return d.feesExpensesRatings != null && d.feesExpensesRatings.category.length > 24;
            });
            this.setState({ extendHeight: shouldExtendHeight });
        }
    }, {
        key: "renderFundsOverviewRow",
        value: function renderFundsOverviewRow(labelKey, rowHeader, subHeader) {
            var cssClass = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "text-left";
            var rowDivider = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

            return _react2.default.createElement(
                "tr",
                { "data-testid": labelKey + "-row", id: labelKey + "-row",
                    className: "category " + (rowDivider ? 'row-divider' : '') + (this.state.extendHeight && labelKey === 'ic-fund-overview-morningstar-category' ? ' height-67' : ''),
                    key: labelKey + "-key" },
                _react2.default.createElement(
                    "td",
                    { key: "0", className: cssClass, "data-testid": "labelKey-label-name" },
                    rowHeader,
                    _react2.default.createElement(
                        "div",
                        { className: "disclaimer" },
                        subHeader
                    )
                )
            );
        }
    }, {
        key: "getFundsOverviewHeaders",
        value: function getFundsOverviewHeaders() {
            var tableRows = [];
            tableRows.push(this.renderFundsOverviewRow('ic-fund-overview-inception-date', "Inception Date", ""));
            tableRows.push(this.renderFundsOverviewRow('ic-fund-overview-asset-class', "Asset Class", ""));
            tableRows.push(this.renderFundsOverviewRow('ic-fund-overview-gross-expense-ratio', "Gross Expense Ratio", ""));
            tableRows.push(this.renderFundsOverviewRow('ic-fund-overview-net-expense-ratio', "Net Expense Ratio", ""));
            tableRows.push(this.renderFundsOverviewRow('ic-fund-overview-morningstar-category', "Morningstar Category", ""));
            tableRows.push(this.renderFundsOverviewRow('ic-fund-overview-morningstar-rating', "Morningstar Rating Overall", "Funds In Category", "text-left", false));

            return tableRows;
        }
    }, {
        key: "getFundsOverviewDataTable",
        value: function getFundsOverviewDataTable(index) {

            var basicInfo = this.props.data[index].basicInfo;
            var feesExpensesRatings = this.props.data[index].feesExpensesRatings;
            var ranking = feesExpensesRatings.morningStarRating;
            var morningstarRatings = (0, _ramda.filter)((0, _ramda.propSatisfies)(function (x) {
                return x === 'overall';
            }, 'period'), feesExpensesRatings.morningstarRatings);
            var fundsInCategory = null;
            if (!(0, _functional_utility.isNilOrEmpty)(morningstarRatings)) {
                fundsInCategory = morningstarRatings[0].fundsRanked;
            }

            var tableRows = [];
            tableRows.push(this.renderFundsOverviewRow('ic-fund-overview-inception-date', _date_formatter2.default.getDateInSpecificFormat(basicInfo.inceptionDate, "MM/DD/yyyy"), "", "text-center"));
            tableRows.push(this.renderFundsOverviewRow('ic-fund-overview-asset-class', basicInfo.assetClass, "", "text-center"));
            tableRows.push(this.renderFundsOverviewRow('ic-fund-overview-gross-expense-ratio', _number_utility2.default.formatToPercentWith2FixedDecimals(feesExpensesRatings.prospectusGrossExpenseRatio), null, "text-center"));
            tableRows.push(this.renderFundsOverviewRow('ic-fund-overview-net-expense-ratio', _number_utility2.default.formatToPercentWith2FixedDecimals(feesExpensesRatings.prospectusNetExpenseRatio), null, "text-center"));
            tableRows.push(this.renderFundsOverviewRow('ic-fund-overview-morningstar-category', feesExpensesRatings.category, null, "text-center"));
            tableRows.push(this.renderFundsOverviewRow('ic-fund-overview-morningstar-rating', this.renderMorningstarRating(ranking), (0, _ramda.isNil)(fundsInCategory) ? '-' : fundsInCategory, "text-center", false));
            if (this.props.data.length > 1) {
                tableRows.push(this.renderDeleteButton(index));
            }
            return tableRows;
        }
    }, {
        key: "getMorningStarRatingsDisclosure",
        value: function getMorningStarRatingsDisclosure() {
            var _this2 = this;

            var morningStarDisclosure = [];
            this.props.data.forEach(function (data, index) {
                var ratings = data.feesExpensesRatings.morningstarRatings;
                var threeYrRatings = (0, _ramda.filter)((0, _ramda.propSatisfies)(function (x) {
                    return x === '3y';
                }, 'period'), ratings);
                var threeYrRatingsText = void 0,
                    fiveYrRatingsText = void 0,
                    tenYrRatingsText = void 0;
                var fiveYrRatings = (0, _ramda.filter)((0, _ramda.propSatisfies)(function (x) {
                    return x === '5y';
                }, 'period'), ratings);
                var tenYrRatings = (0, _ramda.filter)((0, _ramda.propSatisfies)(function (x) {
                    return x === '10y';
                }, 'period'), ratings);
                if (!(0, _functional_utility.isNilOrEmpty)(threeYrRatings) && !(0, _ramda.isNil)(threeYrRatings[0].msRating) && !(0, _ramda.isNil)(threeYrRatings[0].fundsRanked)) {
                    threeYrRatingsText = "Three-year rating " + threeYrRatings[0].msRating + " stars " + threeYrRatings[0].fundsRanked + " Funds";
                }
                if (!(0, _functional_utility.isNilOrEmpty)(fiveYrRatings) && !(0, _ramda.isNil)(fiveYrRatings[0].msRating) && !(0, _ramda.isNil)(fiveYrRatings[0].fundsRanked)) {
                    fiveYrRatingsText = ", Five-year rating " + fiveYrRatings[0].msRating + " stars " + fiveYrRatings[0].fundsRanked + " Funds";
                }
                if (!(0, _functional_utility.isNilOrEmpty)(tenYrRatings) && !(0, _ramda.isNil)(tenYrRatings[0].msRating) && !(0, _ramda.isNil)(tenYrRatings[0].fundsRanked)) {
                    tenYrRatingsText = ", Ten-year rating " + tenYrRatings[0].msRating + " stars " + tenYrRatings[0].fundsRanked + " Funds";
                }

                var fundName = _this2.props.data[index].basicInfo.name;
                var disclosureText = fundName + ": " + ((0, _ramda.isNil)(threeYrRatingsText) ? '' : threeYrRatingsText) + ((0, _ramda.isNil)(fiveYrRatingsText) ? '' : fiveYrRatingsText) + ((0, _ramda.isNil)(tenYrRatingsText) ? '' : tenYrRatingsText);
                morningStarDisclosure.push(disclosureText);
            });

            return morningStarDisclosure.join('</br>');
        }
    }, {
        key: "renderDeleteButton",
        value: function renderDeleteButton(index) {
            var _this3 = this;

            var ticker = (0, _ramda.pathOr)('', ['data', index, 'stats', 'categoryStats', 'funds', 0, 'ticker'], this.props);
            return _react2.default.createElement(
                "div",
                { className: "display-flex align-items-center justify-content-center height-35" },
                _react2.default.createElement(
                    "button",
                    { "data-testid": "ic-delete-button", type: "button", tabIndex: "0",
                        "aria-label": "Delete " + ticker + " fund",
                        className: "text-hide",
                        onClick: function onClick() {
                            return _this3.props.invokeFundDelete(index, 'Card');
                        },
                        onKeyDown: function onKeyDown(event) {
                            return _accessibility_utility2.default.handleEnterClick(_this3, event, _this3.props.invokeFundDelete.bind(_this3, index, 'Card'));
                        } },
                    _react2.default.createElement("span", { className: "ic-delete-button" })
                )
            );
        }
    }, {
        key: "renderMorningstarRating",
        value: function renderMorningstarRating(rankNumber) {
            var rowCollection = [];
            if (!(0, _ramda.isNil)(rankNumber)) {
                var srOnlyText = rankNumber + " stars out of 5";
                for (var i = 0; i < 5; i++) {
                    var iconColor = "";
                    var noRatingStar = "";
                    if (i >= rankNumber) {
                        iconColor = " font-slate-grey";
                        noRatingStar = "-no-star";
                    }
                    rowCollection.push(_react2.default.createElement("span", { className: "ic-morningstar" + noRatingStar + " full width-20 margin-left-8" + iconColor, key: i,
                        "data-testid": "morningstar-overall-rating" + noRatingStar, id: "morningstar-overall-rating" }));
                }
                return _react2.default.createElement(
                    "div",
                    { className: "font-light font-25 margin-top-5 margin-bottom-5", "data-testid": "ic-morningstar-overall-rating", id: "ic-morningstar-overall-rating" },
                    _react2.default.createElement(
                        "div",
                        { className: "height-20 display-flex justify-content-center" },
                        rowCollection
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "sr-only display-flex justify-content-center width-auto height-auto" },
                        srOnlyText
                    )
                );
            }
        }
    }, {
        key: "renderFundOverviewCardColumns",
        value: function renderFundOverviewCardColumns() {
            var _this4 = this;

            var cards = [];
            this.props.data.forEach(function (data, index) {
                cards.push(_this4.renderFundOverviewCard(data.basicInfo, index));
            });
            var emptyRows = 3 - this.props.data.length;
            for (var i = 0; i < emptyRows; i++) {
                var enableAddAFund = i === 0;
                cards.push(this.renderFundOverviewCard(null, this.props.data.length + i, enableAddAFund));
            }
            return cards;
        }
    }, {
        key: "renderFundOverviewCard",
        value: function renderFundOverviewCard(data, index, enableAddAFund) {
            var _this5 = this;

            var cardHeightCSS = this.state.extendHeight ? 'height-470' : 'height-450';
            if ((0, _ramda.isNil)(data)) {
                return _react2.default.createElement(
                    "div",
                    {
                        onClick: function onClick() {
                            return enableAddAFund && _this5.props.invokeFundSelector(index, 'Card');
                        },
                        className: "col-sm-3 col-md-3 col-lg-3 col-xlg-3" },
                    _react2.default.createElement(
                        "div",
                        { className: "ic-fund-overview-card-container " + (enableAddAFund ? 'display-flex align-items-center justify-content-center' : 'empty') + " " + cardHeightCSS },
                        enableAddAFund && _react2.default.createElement(
                            "button",
                            { "data-testid": "ic-add-a-fund",
                                tabIndex: 0,
                                "aria-label": "add a fund",
                                style: { "background-color": "inherit" },
                                onKeyDown: function onKeyDown(event) {
                                    return _accessibility_utility2.default.handleEnterClick(_this5, event, _this5.props.invokeFundSelector.bind(_this5, index, 'Card'));
                                }
                            },
                            _react2.default.createElement("span", { className: "ic-add-a-fund display-block text-center" }),
                            _react2.default.createElement(
                                "span",
                                null,
                                " Add a fund"
                            )
                        )
                    )
                );
            } else {
                var basicInfo = this.props.data[index].basicInfo;
                var stats = this.props.data[index].stats;
                var ticker = "";
                if (!(0, _functional_utility.isNilOrEmpty)(stats.categoryStats) && !(0, _ramda.isNil)(stats.categoryStats.funds[0])) {
                    ticker = stats.categoryStats.funds[0].ticker;
                }
                return _react2.default.createElement(
                    "div",
                    { className: "col-sm-3 col-md-3 col-lg-3 col-xlg-3" },
                    _react2.default.createElement(
                        "div",
                        { className: "ic-fund-overview-card-container text-center padding-top-15 " + cardHeightCSS },
                        _react2.default.createElement(
                            "div",
                            null,
                            _react2.default.createElement(
                                "div",
                                { className: "body-bold" },
                                " ",
                                ticker,
                                " "
                            ),
                            _react2.default.createElement(
                                "div",
                                { className: "body-bold height-60 ic-cut-text", title: basicInfo.name },
                                basicInfo.name
                            )
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "padding-top-10 padding-horizontal-10" },
                            _react2.default.createElement(_table_component2.default, {
                                tableRows: this.getFundsOverviewDataTable(index),
                                tableHeadersStyle: { "textAlign": "center", "paddingTop": 10 },
                                breakpoint: this.props.breakpoint
                            })
                        )
                    )
                );
            }
        }
    }, {
        key: "render",
        value: function render() {
            var disclosure = [];
            disclosure.push(_string_utility2.default.getLocalizedString(this.props.intl, "", "pdp-ic-fund-overview-disclosure-text-1"));
            disclosure.push(this.getMorningStarRatingsDisclosure());
            disclosure.push(_string_utility2.default.getLocalizedString(this.props.intl, "", "pdp-ic-fund-overview-disclosure-text-2"));

            var disclosureText = (0, _ramda.isNil)(this.props.disclosureText) ? [disclosure.join('')] : this.props.disclosureText;
            return _react2.default.createElement(
                "div",
                { className: "padding-horizontal-50 padding-top-150 row" },
                _react2.default.createElement(
                    "div",
                    { className: "col-sm-3 col-md-3 col-lg-3 col-xlg-3 padding-top-68" },
                    _react2.default.createElement(
                        "div",
                        { className: "font-bold" },
                        _react2.default.createElement(
                            "h3",
                            { className: "sub-header-2" },
                            _string_utility2.default.getLocalizedString(this.props.intl, "Overview", "pdp-ic-fund-overview-title")
                        )
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "padding-top-15" },
                        _react2.default.createElement(_table_component2.default, {
                            tableRows: this.getFundsOverviewHeaders(),
                            tableHeadersStyle: { "textAlign": "right", "paddingTop": 10 },
                            breakpoint: this.props.breakpoint
                        })
                    )
                ),
                _react2.default.createElement(
                    "div",
                    null,
                    this.renderFundOverviewCardColumns()
                ),
                !(0, _functional_utility.isNilOrEmpty)(disclosureText) && _react2.default.createElement(
                    "div",
                    { className: "padding-bottom-50" },
                    _react2.default.createElement(_disclosure2.default, {
                        disclosureText: disclosureText,
                        placementId: "icLiteFundOverview",
                        arialabel: "Read more about Funds Overview"
                    })
                )
            );
        }
    }]);

    return IcFundOverview;
}(_react2.default.Component);

exports.default = (0, _reactIntl.injectIntl)(IcFundOverview, { withRef: true });